var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProimage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:upload-cloud",
    clipPath: "url(#clip0_521_839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6097 15.3789L11.8314 11.6006L8.0531 15.3789",
    stroke: "#42D27B",
    strokeWidth: 2.26697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8314 11.6006V20.1017",
    stroke: "#42D27B",
    strokeWidth: 2.26697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7564 17.6362C20.6777 17.1339 21.4055 16.3392 21.8249 15.3774C22.2444 14.4156 22.3315 13.3414 22.0727 12.3246C21.8139 11.3077 21.2238 10.406 20.3956 9.76173C19.5674 9.11747 18.5482 8.76736 17.4989 8.76667H16.3087C16.0228 7.6608 15.49 6.63414 14.7502 5.76387C14.0104 4.8936 13.0829 4.20236 12.0375 3.74212C10.9921 3.28189 9.85596 3.06463 8.7145 3.10669C7.57305 3.14874 6.45599 3.44902 5.44729 3.98493C4.43859 4.52085 3.56451 5.27846 2.89075 6.20082C2.217 7.12317 1.76111 8.18627 1.55736 9.31017C1.3536 10.4341 1.40729 11.5895 1.71438 12.6897C2.02146 13.7899 2.57396 14.8061 3.33034 15.662",
    stroke: "#42D27B",
    strokeWidth: 2.26697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6097 15.3789L11.8314 11.6006L8.0531 15.3789",
    stroke: "#42D27B",
    strokeWidth: 2.26697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6697,
    height: 22.6697,
    fill: "white",
    transform: "translate(0.496582 0.265625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProimage1);
export default __webpack_public_path__ + "static/media/proimage1.7cdc6932d1ae65e711b3c4f107036064.svg";
export { ForwardRef as ReactComponent };